export const emailValidationRule = (onValidateEmail: (email: string) => Promise<string | undefined>): any[] => ([
  { type: "email", message: "This input is not a valid email address" },
  {
    validator: async (_: any, value: string) => {
      const validationFailReason = value && value.trim().length > 0 && await onValidateEmail(value)
      if (validationFailReason) {
        throw new Error(validationFailReason)
      }
    }
  }])